module.exports = __webpack_public_path__ + "static/slagen-hex-blue-7816e2315d183fcb5d6c44c64655a4f4.png";